import React, { useEffect, useRef } from "react";
import { Button } from "web/react/emo/button";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./compare-prices-button.css";

export interface ComparePricesButtonProps {
    onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    onShow?: () => void;
    count: number;
}

export function ComparePricesButton({
    onClick,
    onShow,
    count,
}: ComparePricesButtonProps): React.ReactElement {
    const comparePricesButtonRef = useRef<HTMLDivElement | null>(null);
    const [isVisible] = useIntersectionObserver(
        {
            rootMargin: "0px",
            threshold: 1,
            once: true,
        },
        comparePricesButtonRef
    );

    useEffect(() => {
        if (isVisible) onShow?.();
    }, [isVisible]);

    return (
        <div
            className={styles.fullWidth}
            ref={comparePricesButtonRef}
            data-testid="compare-prices-button"
        >
            <Button
                variant="secondary"
                width="full"
                title={gettext("product.buy_area.compare_count_prices.cta", {
                    count,
                })}
                condensed
                onClick={onClick}
            />
        </div>
    );
}
